import { render, staticRenderFns } from "./StepTapes.vue?vue&type=template&id=127255e8&"
import script from "./StepTapes.vue?vue&type=script&lang=ts&"
export * from "./StepTapes.vue?vue&type=script&lang=ts&"
import style0 from "./StepTapes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127255e8')) {
      api.createRecord('127255e8', component.options)
    } else {
      api.reload('127255e8', component.options)
    }
    module.hot.accept("./StepTapes.vue?vue&type=template&id=127255e8&", function () {
      api.rerender('127255e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/requirement/StepTapes.vue"
export default component.exports